import { ReactNode } from 'react';

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

export const PageLayout = ({ children, className = '' }: PageLayoutProps) => {
  return (
    <main className='flex-col flex-1 items-start gap-4 px-5 py-4 sm:px-5 sm:py-4 md:gap-8 bg-white'>
      <section className={`flex-col flex-1 items-start gap-4 px-5 py-4 sm:px-5 sm:py-4 md:gap-8 bg-white ${className}`}>
        <div className="flex flex-col items-center justify-center gap-8 w-full">
          {children}
        </div>
      </section>
    </main>
  );
};
